import cx from 'classnames';
import { ListItem, ListItemPlaceholder } from 'mk2/components/ListItem';
import useEventCallback from 'mk2/hooks/useEventCallback';
import React from 'react';
import styles from './CategorySuggestionListItem.mscss';

interface Suggestion {
    category: string;
    text: string;
}

interface OwnProps<TSuggestion extends Suggestion = Suggestion> {
    className?: string;
    suggestion: TSuggestion;
    isLast?: boolean;
    onClick(suggestion: TSuggestion);
}

type Props = OwnProps;

const CategorySuggestionListItem: React.FunctionComponent<Props> = ({
    className,
    suggestion,
    onClick,
    isLast = false,
}) => {
    const onClickCallback = useEventCallback(() => {
        onClick(suggestion);
    }, [suggestion, onClick]);

    return (
        <ListItem
            className={cx(styles.CategorySuggestionListItem, className)}
            isLast={isLast}
            onClick={onClickCallback}
            data-cy={`category-${suggestion.category}`}
        >
            <div className={styles.CategorySuggestionListItem__text}>{suggestion.text}</div>
        </ListItem>
    );
};

CategorySuggestionListItem.displayName = 'CategorySuggestionListItem';

export default React.memo<Props>(CategorySuggestionListItem);

interface PlaceholderOwnProps {
    isLast?: boolean;
}

let CategorySuggestionListItemPlaceholder: React.FunctionComponent<PlaceholderOwnProps> = ({ isLast }) => (
    <ListItemPlaceholder isLast={isLast} />
);

CategorySuggestionListItemPlaceholder.displayName = 'CategorySuggestionListItemPlaceholder';
CategorySuggestionListItemPlaceholder = React.memo<PlaceholderOwnProps>(CategorySuggestionListItemPlaceholder);

export { CategorySuggestionListItemPlaceholder };
